import React from "react";
import { DISC_DOT_BG, type DisciplineKey } from "./disciplineColor";

/**
 * Тег дисциплины DS (canon-session 2026-07-24): mono-подпись + точка-цвет
 * дисциплины в тонкой рамке-пилюле. `label` — уже переведённая подпись
 * (i18n на стороне вызывающего, компонент не хардкодит имена).
 */
export function Tag({
  discipline,
  children,
}: {
  discipline: DisciplineKey;
  children: React.ReactNode;
}) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-border font-mono text-[11px] text-text-secondary pl-2 pr-2.5 py-1">
      <span className={`w-[7px] h-[7px] rounded-full shrink-0 ${DISC_DOT_BG[discipline]}`} />
      {children}
    </span>
  );
}
